import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header as BaseHeader } from '@lux/components';
import { logoutUser } from '../../actions';
import { withRouter } from 'react-router-dom';

export class Header extends Component {
  handleLogout = () => {
    this.props.logoutUser();
  };

  render() {
    const { showAvatar } = this.props;

    return (
      <BaseHeader
        logo={{ link: '#', alt: 'Singtel' }}
        menuItems={[
          { item: { active: true, title: '', src: '#' }, subMenu: [] }
        ]}
        showAvatar={showAvatar}
        avatarMenuItems={[
          {
            title: 'Logout',
            href: `#`,
            onClick: () => this.handleLogout()
          }
        ]}
      />
    );
  }
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  return {
    logoutUser: () => dispatch(logoutUser())
  };
};

export default withRouter(connect(null, mapDispatchToProps)(Header));
